/** `KeyboardEvent.key` values the web app reacts to. */
export const KeyboardKey = { Escape: 'Escape' } as const;
export type KeyboardKey = (typeof KeyboardKey)[keyof typeof KeyboardKey];

/** `PointerEvent.pointerType` values. */
export const PointerKind = { Mouse: 'mouse', Pen: 'pen', Touch: 'touch' } as const;
export type PointerKind = (typeof PointerKind)[keyof typeof PointerKind];
